import { Navigate, createFileRoute } from '@tanstack/react-router';

import { ShigoPermission } from '../features/auth/permissions';
import { useShigoPermissions } from '../features/auth/useShigoPermissions';

export const Route = createFileRoute('/admin/')({
  component: AdminIndexRoute,
});

function AdminIndexRoute() {
  const { can } = useShigoPermissions();
  return can(ShigoPermission.AdminUsersRead) ? (
    <Navigate to="/admin/users" replace />
  ) : (
    <Navigate to="/admin/changelog" replace />
  );
}
